window.axeptioSettings= {
    clientId:"6476fe887fa32c7ce2428c64",
};

(function(d,s) {
    var t = d.getElementsByTagName(s)[0],e = d.createElement(s);
    e.async = true;e.src = "//static.axept.io/sdk.js";
    t.parentNode.insertBefore(e, t);
})(document, "script");